import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  Renderer2,
  Sanitizer,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { ComunicationsService } from 'src/app/services/comunications.service';

@Component({
  selector: 'app-new-comunication',
  templateUrl: './new-comunication.component.html',
  styleUrls: ['./new-comunication.component.scss'],
})
export class NewComunicationComponent implements OnInit, AfterViewInit {
  emailSubscription: FormGroup = new FormGroup({});
  idSpace!: number;
  idCompany!: number;

  // editorConfig!: AngularEditorConfig;
  public editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '300px',
    maxHeight: '800px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Escribe aquí el mensaje',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Satoshi-Regular',
    defaultFontSize: '',
    fonts: [{ class: 'arial', name: 'Arial' }],
    // uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['subscript', 'superscript', 'indent', 'outdent', 'fontName'],
      [
        'textColor',
        'backgroundColor',
        'unlink',
        'insertVideo',
        'removeFormat',
        'insertImage',
        'toggleEditorMode',
      ],
    ],
  };

  @ViewChild('editor') editor;

  filePath = '';
  nameFile!: string;
  emailSend: boolean = false;
  files: any[] = [];
  isSizeExceeded: boolean = false;
  savedSelection: Range | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<NewComunicationComponent>,
    private formBuilder: FormBuilder,
    private comunicationService: ComunicationsService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.idCompany = this.data.idCompany;
      this.idSpace = this.data.idSpace;
    }
    this.data ? (this.idCompany = this.data.idCompany) : null;
    this.emailSubscription = this.formBuilder.group({
      subject: ['', [Validators.required, Validators.maxLength(200)]],
      body: [
        '<div style="text-align: left;"></div>',
        [Validators.required, Validators.maxLength(5000)],
      ],
      files: [null],
    });
    // this.editorConfig = this.comunicationService.editorConfig;
  }

  ngAfterViewInit(): void {
    const toolbar = document.querySelector('.angular-editor-toolbar');

    if (toolbar) {
      this.renderer.listen(toolbar, 'click', () => {
        const buttons = document.querySelectorAll('.ae-picker-item');
        buttons.forEach((btn: any) => {
          const text = btn.textContent.trim();
          const forbidden = [
            'Heading 4',
            'Heading 5',
            'Heading 6',
            'Heading 7',
            'Predefined',
            'Standard',
          ];

          if (forbidden.includes(text)) {
            this.renderer.setStyle(btn, 'display', 'none');
          }
        });
      });
    }
  }

  cancelSend() {
    this.dialogRef.close();
  }

  sendEmail() {
    this.emailSend = true;
    let payload = this.emailSubscription.value;

    let body = payload.body;

    if (this.emailSubscription.valid) {
      let payloadForm = {
        subject: payload.subject,
        body: body,
        company_id: this.idCompany,
        files: [],
      };

      if (payload.files && payload.files.length > 0) {
        let filesBase64 = [];

        let processedFiles = 0;
        const totalFiles = payload.files.length;

        payload.files.forEach((file: File) => {
          const reader = new FileReader();

          reader.readAsDataURL(file);
          reader.onload = () => {
            const fileBase64 = reader.result as string;
            filesBase64.push({
              name: file.name,
              base64: fileBase64,
            });

            processedFiles++;

            if (processedFiles === totalFiles) {
              filesBase64.forEach((fileData) => {
                payloadForm.files.push({
                  name: fileData.name,
                  file: fileData.base64,
                });
              });

              // Enviar el FormData con los archivos
              this.comunicationService
                .sendSubscribersEmail(this.idSpace, payloadForm)
                .subscribe({
                  next: (res) => {
                    this.dialogRef.close({ result: res });
                  },
                  error: (err) => {
                    this.emailSend = false;
                    this.dialogRef.close({
                      err: 'Se ha producido un error al mandar el mensaje.',
                    });
                  },
                });
            }
          };

          reader.onerror = (error) => {
            console.error('Error al leer el archivo', error);
            this.emailSend = false;
          };
        });
      } else {
        // Si no hay archivos, solo enviamos el resto del FormData
        this.comunicationService
          .sendSubscribersEmail(this.idSpace, payloadForm)
          .subscribe({
            next: (res) => {
              this.dialogRef.close({ result: res });
            },
            error: (err) => {
              this.emailSend = false;
              this.dialogRef.close({
                err: 'Se ha producido un error al mandar el mensaje.',
              });
            },
          });
      }
    }
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
    this.emailSubscription.patchValue({
      files: this.files.length > 0 ? this.files : null,
    });

    const totalSize = this.files.reduce((acc, f) => acc + f.size, 0);
    this.isSizeExceeded = totalSize > 10 * 1024 * 1024;
  }

  onFileChange(event) {
    if (event.target.files && event.target.files.length) {
      const files = event.target.files;
      let formData = new FormData();
      let fileArray = [];
      let totalSize = 0;

      // Iterar sobre los archivos y calcular el tamaño total y validar extensión
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (
          file.type !== 'application/pdf' &&
          !file.name.toLowerCase().endsWith('.pdf')
        ) {
          this.openInfoCard(
            'Solo se permiten archivos en formato .pdf.',
            false,
            true,
          );
          this.isSizeExceeded = true;
          this.files = [];
          this.emailSubscription.patchValue({ files: [] });
          event.target.value = '';
          return;
        }

        totalSize += file.size;
        formData.append('files[]', file, file.name);
        fileArray.push(file);
      }

      const maxSize = 10 * 1024 * 1024;
      if (totalSize > maxSize) {
        this.openInfoCard(
          'El tamaño total de los archivos <br> no puede superar los 10 MB.',
          false,
          true,
        );
        this.isSizeExceeded = true;
        this.files = [];
        this.emailSubscription.patchValue({
          files: [],
        });
        event.target.value = '';
        return;
      }

      this.files = fileArray;
      this.isSizeExceeded = false;
      this.emailSubscription.patchValue({
        files: fileArray,
      });
    }
  }

  openInfoCard(
    msg: string,
    disabledClose: boolean = false,
    icon: boolean = true,
  ) {
    const dialogRef = this.dialog.open(InfoCardComponent, {
      panelClass: ['info-dialog'],
      disableClose: disabledClose,
      data: {
        icon: icon,
        text: msg,
        btnCancel: false,
      },
    });
  }
}
